import React from 'react';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { BetGliderState } from 'src/domains/sportsbook/state/betGliderState/BetGliderState';
import { observer } from 'src/utils/mobx-react';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { BetGliderCta } from 'src/ui/assets/icons/other/BetGliderCta';
import { StreamingState } from 'src/domains/sportsbook/state/streamingState/StreamingState';

interface RaceBetGliderButtonPropsType {
    race: EventModel;
}

export const RaceBetGliderButton = observer(
    'RaceBetGliderButton',
    ({ race }: RaceBetGliderButtonPropsType): JSX.Element | null => {
        const common = useCommon();
        const betGliderState = BetGliderState.get(common);
        const starRouter = StarRouter.get(common);
        const streamingState = StreamingState.get(common);

        const handleBetGliderClick = (): void => {
            if (common.session.userId === null) {
                starRouter.redirectToLogin();
                return;
            }
            streamingState.closeStream();
            betGliderState.openBetGlider(race);
        };

        return <BetGliderCta onClick={handleBetGliderClick} />;
    }
);
